// @flow

import React, { Component } from 'react';
import skiliftfooter from './images/Ski-Lifts-Logo-Footer.png';
import lifttologo from './images/Lifts-To-Logo.png';
import golfdrives from './images/Golf-Drives-Logo.png';
import sealift from './images/Sea-Lifts-Logo.png';
import award from './images/award-winning.png';
import './styles.css';

class Footer extends Component<{}> {
  render() {
    return (
      <footer id="colophon" className="site-footer updated-footer" role="contentinfo">
        <div className="site-info">
          <div className="row">
            <div className="col-md-12 col-sm-offset-2 col-md-offset-0" id="footer">
              <div className="row menu">
                <div className="col-md-3">
                  <div className="menu-desktop-footer-block-1-container">
                    <ul id="footer-menu-1" className="menu">
                      <li id="menu-item-18872"
                          className="menu-item menu-item-type-custom menu-item-object-custom menu-item-18872">
                        <a href="https://www.ski-lifts.com/about-us/">About Us</a>
                      </li>
                      <li id="menu-item-18875"
                          className="menu-item menu-item-type-custom menu-item-object-custom menu-item-18875">
                        <a href="https://www.ski-lifts.com/airport-transfers/geneva/where-to-find-us-at-geneva-airport/">Find us at Geneva Airport</a>
                      </li>
                      <li id="menu-item-20847"
                          className="menu-item menu-item-type-post_type menu-item-object-page menu-item-20847">
                        <a href="https://www.ski-lifts.com/faqs/">Frequently Asked Questions</a>
                      </li>
                      <li id="menu-item-18874"
                          className="menu-item menu-item-type-custom menu-item-object-custom menu-item-18874">
                        <a href="https://www.ski-lifts.com/guides/">Guides</a>
                      </li>
                      <li id="menu-item-22340"
                          className="menu-item menu-item-type-post_type menu-item-object-page menu-item-22340">
                        <a href="https://www.ski-lifts.com/our-services/">Our Services</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="menu-desktop-footer-block-2-container">
                    <ul id="footer-menu-2" className="menu">
                      <li id="menu-item-20911"
                          className="menu-item menu-item-type-custom menu-item-object-custom menu-item-20911">
                        <a href="https://www.ski-lifts.com/open-an-account/">Open an Account</a>
                      </li>
                      <li id="menu-item-20912"
                          className="menu-item menu-item-type-custom menu-item-object-custom menu-item-20912">
                        <a href="https://www.ski-lifts.com/loyalty-points/">Loyalty Points</a>
                      </li>
                      <li id="menu-item-20913"
                          className="menu-item menu-item-type-custom menu-item-object-custom menu-item-20913">
                        <a href="https://www.ski-lifts.com/become-an-affiliate/">Become an Affiliate</a>
                      </li>
                      <li id="menu-item-20914"
                          className="menu-item menu-item-type-custom menu-item-object-custom menu-item-20914">
                        <a href="https://www.ski-lifts.com/jobs/">Careers</a>
                      </li>
                      <li id="menu-item-20915"
                          className="menu-item menu-item-type-custom menu-item-object-custom menu-item-20915">
                        <a href="https://www.ski-lifts.com/train-station-transfers/">Train Station Transfers</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="menu-desktop-footer-block-3-container">
                    <ul id="footer-menu-3" className="menu">
                      <li id="menu-item-20894"
                          className="menu-item menu-item-type-custom menu-item-object-custom menu-item-20894">
                        <a href="https://www.lifts.to/terms-and-conditions/">Terms and Conditions</a>
                      </li>
                      <li id="menu-item-20895"
                          className="menu-item menu-item-type-custom menu-item-object-custom menu-item-20895">
                        <a href="https://www.lifts.to/terms-of-use/">Terms of Use</a>
                      </li>
                      <li id="menu-item-20896"
                          className="menu-item menu-item-type-custom menu-item-object-custom menu-item-20896">
                        <a href="https://www.lifts.to/privacy-policy/">Privacy</a>
                      </li>
                      <li id="menu-item-20897"
                          className="menu-item menu-item-type-custom menu-item-object-custom menu-item-20897">
                        <a href="https://www.lifts.to/cookie-policy/">Cookies</a>
                      </li>
                      <li id="menu-item-20898"
                          className="menu-item menu-item-type-custom menu-item-object-custom menu-item-20898">
                        <a href="https://www.ski-lifts.com/sitemap_index.xml">Sitemap</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-3 col-6">
                  <img alt="World Ski Award Winners"
                       src={award}
                       style={{width:"80%"}}className="world-ski-award-winners"/>
                </div>
              </div>

              <div id="other-brands">
                <p className="award-winning-group"> Part of the award-winning transfer group </p>
                <div className="row">
                  <div className="col-sm-2"></div>
                  <div className="col-md-8 col-sm-12 footer-logos">
                    <div className="row">
                      <div className="col-md-4 col-3 clearfix d-none d-md-block d-lg-block"></div>
                      <div className="col-6 col-md-4 col-sm-5 clearfix text-center lifts-to-logo-footer">
                        <img alt="Lifts To Logo"
                             src={lifttologo}
                             style={{width:"80%"}}/>
                      </div>
                      <div className="col-md-4 col-3"></div>
                      <div className="col-12" style={{padding:"10px 0"}}></div>
                      <div className="col-sm-2 d-none d-md-block d-lg-block"></div>
                      <div className="col-4 col-sm-3 footer-logo-mx-width">
                        <a href="https://www.ski-lifts.com/" rel="noopener">
                          <img alt="Lifts To Logo Dark"
                               src={ skiliftfooter}
                               style={{width:"100%", marginLeft:'-10px'}}/>
                        </a>
                      </div>
                      <div className="col-4 col-sm-3 footer-logo-mx-width">
                        <a href="https://www.sea-lifts.com/" rel="noopener">
                          <img width="126" height="33" alt="Sea Lifts Logo"
                               src={sealift}
                               style={{width:"100%"}}/>
                        </a>
                      </div>
                      <div className="col-4 col-sm-3 footer-logo-mx-width">
                        <a href="https://www.golf-drives.com/" rel="noopener">
                          <img width="126"  alt="Golf Drives Logo"
                               src={golfdrives}
                               style={{width:"100%", height:"82%",marginLeft: "10px"}}/>
                        </a>
                      </div>
                      <div className="col-sm-1 d-none d-md-block d-lg-block"></div>
                    </div>
                  </div>
                  <div className="col-2 clearfix"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
